import React from "react";
import { FacebookFilled, TwitterCircleFilled, InstagramFilled, LinkedinFilled } from "@ant-design/icons";
import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";

import {
  StyledFooter,
  BrandContainer,
  LogoImage,
  BrandDescription,
  SocialLinks,
  SocialIcon,
  FooterSection,
  FooterTitle,
  FooterLinks,
  FooterLink,
  CopyrightBar,
  CopyrightContent,
  CopyrightText,
  LegalLinks,
  LegalLink,
} from "./Footer.styles";
import { SectionContentWrapper } from "../../styled";

export const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <StyledFooter>
        <SectionContentWrapper>
          <Row gutter={[48, 48]}>
            {/* Brand Section */}
            <Col xs={24} md={8}>
              <BrandContainer>
                <LogoImage />
                <BrandDescription>{t("home.footer.description")}</BrandDescription>
                <SocialLinks>
                  <SocialIcon>
                    <FacebookFilled />
                  </SocialIcon>
                  <SocialIcon>
                    <TwitterCircleFilled />
                  </SocialIcon>
                  <SocialIcon>
                    <InstagramFilled />
                  </SocialIcon>
                  <SocialIcon>
                    <LinkedinFilled />
                  </SocialIcon>
                </SocialLinks>
              </BrandContainer>
            </Col>

            {/* Categories */}
            <Col xs={12} md={5}>
              <FooterSection>
                <FooterTitle>{t("home.footer.categories")}</FooterTitle>
                <FooterLinks>
                  <FooterLink href="#">{t("home.footer.massage")}</FooterLink>
                  <FooterLink href="#">{t("home.footer.barber")}</FooterLink>
                  <FooterLink href="#">{t("home.footer.fitnessCoach")}</FooterLink>
                  <FooterLink href="#">{t("home.footer.psychologist")}</FooterLink>
                  <FooterLink href="#">{t("home.footer.allCategories")}</FooterLink>
                </FooterLinks>
              </FooterSection>
            </Col>

            {/* Company */}
            <Col xs={12} md={5}>
              <FooterSection>
                <FooterTitle>{t("home.footer.company")}</FooterTitle>
                <FooterLinks>
                  <FooterLink href="#">{t("home.footer.aboutUs")}</FooterLink>
                  <FooterLink href="#">{t("home.footer.howItWorks")}</FooterLink>
                  <FooterLink href="#">{t("home.footer.forBusiness")}</FooterLink>
                  <FooterLink href="#">{t("home.footer.careers")}</FooterLink>
                  <FooterLink href="#">{t("home.footer.contact")}</FooterLink>
                </FooterLinks>
              </FooterSection>
            </Col>

            {/* Support */}
            <Col xs={12} md={6}>
              <FooterSection>
                <FooterTitle>{t("home.footer.support")}</FooterTitle>
                <FooterLinks>
                  <FooterLink href="#">{t("home.footer.helpCenter")}</FooterLink>
                  <FooterLink href="#">{t("home.footer.privacyPolicy")}</FooterLink>
                  <FooterLink href="#">{t("home.footer.termsOfService")}</FooterLink>
                  <FooterLink href="#">{t("home.footer.trustAndSafety")}</FooterLink>
                </FooterLinks>
              </FooterSection>
            </Col>
          </Row>
        </SectionContentWrapper>
      </StyledFooter>

      {/* Copyright Bar */}
      <CopyrightBar>
        <SectionContentWrapper>
          <CopyrightContent>
            <CopyrightText>© 2025 Trustbook. All rights reserved.</CopyrightText>
            <LegalLinks>
              <LegalLink href="#">Privacy Policy</LegalLink>
              <LegalLink href="#">Terms of Service</LegalLink>
              <LegalLink href="#">Cookie Policy</LegalLink>
            </LegalLinks>
          </CopyrightContent>
        </SectionContentWrapper>
      </CopyrightBar>
    </>
  );
};
